<template>
    <vx-card title="Purchase Order">
        <div class="flex vx-input-group">
            <vs-tabs :value="activeTab">
                <vs-tab label="Draft">
                    <tab-draft></tab-draft>
                </vs-tab>
                <vs-tab label="Waiting">
                    <tab-waiting></tab-waiting>
                </vs-tab>
                <vs-tab label="Inquiry">
                    <tab-inquiry></tab-inquiry>
                </vs-tab>
                <!-- setelah di approve langsung ke release -->
                <vs-tab label="Released">
                    <tab-released></tab-released>
                </vs-tab>
                <vs-tab label="Rejected">
                    <tab-rejected></tab-rejected>
                </vs-tab>
                <vs-tab label="Canceled">
                    <tab-canceled></tab-canceled>
                </vs-tab>
                <vs-tab label="Amended">
                    <tab-amended></tab-amended>
                </vs-tab>
                <vs-tab label="Closed">
                    <tab-closed></tab-closed>
                </vs-tab>
                <vs-tab label="Log Import">
                    <tab-log></tab-log>
                </vs-tab>
            </vs-tabs>
        </div>
    </vx-card>
</template>
<script>
import TabAmended from "./TabAmended.vue";
import TabApproved from "./TabApproved.vue";
import TabCanceled from "./TabCanceled.vue";
import TabClosed from "./TabClosed.vue";
import TabDraft from "./TabDraft.vue";
import TabRejected from "./TabRejected.vue";
import TabReleased from "./TabReleased.vue";
import TabWaiting from "./TabWaiting.vue";
import TabInquiry from "./TabInquiry.vue";
import TabLog from "./TabLogImport.vue";
export default {
    components: {
        TabAmended,
        TabApproved,
        TabCanceled,
        TabClosed,
        TabDraft,
        TabRejected,
        TabReleased,
        TabWaiting,
        TabInquiry,
        TabLog,
    },
    data() {
        return {
            activeTab: sessionStorage.getItem('activeTabPO') ? sessionStorage.getItem('activeTabPO') : "0",
        }
    },
    methods: {},
    mounted(){
        console.log("index ===== ", sessionStorage.getItem('activeTabPO'))
    }
}
</script>
